<script>
import NuttremaLoader from 'components/ui/panels/nuttrema-loader';

export default {
  name: 'abstract-widget',
  components: {
    NuttremaLoader,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/widgets/abstract-widget.vue